



















































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'nuxt-property-decorator'
import { mapGetters } from 'vuex'
import DotFlashing from '../shared/DotFlashing.vue'
import NotFound from '~/components/consumer_map/NotFound.vue'
import InfoCardV3 from '~/components/consumer_map_v3/InfoCardV3.vue'
import InfoCardListItemV3 from '~/components/consumer_map_v3/InfoCardListItemV3.vue'
import { Events } from '~/utils/eventLayers'
import { MapSidebarTabs } from '~/enums/map'
import { consumerMapStore } from '~/store'

@Component({
  components: {
    NotFound,
    InfoCardV3,
    InfoCardListItemV3,
    DotFlashing,
  },
  computed: {
    ...mapGetters('consumer-map', {
      isMapHiddenConsumerMapV3: 'isMapHiddenConsumerMapV3',
      reorderSidepanelPropertyTabs: 'reorderSidepanelPropertyTabs',
      activeMapTab: 'activeMapTab',
    }),
  },
})
export default class MapPropertiesList extends Vue {
  isMapHiddenConsumerMapV3: boolean
  reorderSidepanelPropertyTabs: boolean
  activeMapTab: string

  @Prop({ default: '' }) homeTabLabel: string
  @Prop({ default: '' }) homesitesTabLabel: string
  @Prop({ default: [] }) homes: Array<any>
  @Prop({ default: [] }) homeSites: Array<any>
  @Prop({ default: false }) loadingHomeSites: Boolean
  @Prop({ default: false }) loadingHomes: Boolean
  @Prop({ default: 0 }) homesCount: number
  @Prop({ default: 0 }) homeSitesCount: number
  @Prop() extendListing: boolean

  activeTab: string = MapSidebarTabs.HOMES
  sidebarTabs: typeof MapSidebarTabs = MapSidebarTabs
  viewMode: 'grid' | 'list' = 'grid'

  firstTimeLoaded: boolean = true

  homesOrder: number = 0
  homeSitesOrder: number = 1

  mounted() {
    if (this.activeMapTab) {
      this.activeTab = this.activeMapTab
    }

    if (this.reorderSidepanelPropertyTabs) {
      this.homesOrder = 1
      this.homeSitesOrder = 0
      if (
        this.homeSitesCount &&
        this.activeMapTab === MapSidebarTabs.HOMESITES
      ) {
        this.toggleTab(MapSidebarTabs.HOMESITES)
      }
    }
  }

  @Watch('loadingHomes')
  onLoadingHomesChanged(newValue: boolean) {
    if (newValue) {
      this.firstTimeLoaded = false
    }
  }

  @Emit('onTabChanged')
  toggleTab(index: MapSidebarTabs): string {
    this.activeTab = index
    consumerMapStore.setActiveMapTab(index)
    return index
  }

  toggleViewMode(index: 'grid' | 'list'): void {
    this.viewMode = index
  }

  handlePrint() {
    Events.actions('actionClick', 'click | print list', 'properties list')
    window.print()
  }

  @Emit('onTileViewChanged')
  handleTileView() {}

  @Emit('setLotInfo')
  setLotInfo(lot: any, type: string, view: string) {
    this.$emit('handlePropertyCardClicked', true)
    Events.lot('lotClick', `click | ${type}`, lot, view)
    return lot
  }

  @Emit('onLotListHover')
  onLotListHover($event?: any) {
    return $event
  }
}
